module.exports = __webpack_public_path__ + "img/theme5.3d540804.png";